/* THIS FILE IS GENERATED BY AssistantEffectTypeScriptGenerator. */
export const assistantEffects = {
  canvasChanged: "canvas",
  customDomainsChanged: "custom-domains",
  hierarchyChanged: "hierarchy",
  httpConnectionsChanged: "http-connections",
  identityChanged: "identity",
  invitationsChanged: "invitations",
  notificationsChanged: "notifications",
  reportingChanged: "reporting",
  settingsChanged: "settings",
  workflowsChanged: "workflows",
} as const

export type AssistantEffect =
  typeof assistantEffects[keyof typeof assistantEffects]

const assistantEffectValues = new Set<string>(Object.values(assistantEffects))

export function isAssistantEffect(value: unknown): value is AssistantEffect {
  return typeof value === 'string' && assistantEffectValues.has(value)
}
